import { billingAddressStyles as styles } from "@insite/content-library/Widgets/CheckoutShipping/BillingAddress";
import getColor from "@insite/mobius/utilities/getColor";
import { commonLinkStyles, customLinkHoverStyles } from "@solveindustrial/Utilities/styleguide";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const commonHeadingShipStyles = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px 16px;
    border-bottom: 1px solid ${getColor(colorStrings.commonBorder)};
    margin: 0;
`;

export const commonShipLinkStyles = css`
    ${commonLinkStyles}
    ${customLinkHoverStyles}

    span {
        font-size: 12px;
        line-height: 16px;
    }
`;

styles.headingGridItem = {
    ...styles.headingGridItem,
    css: css`
        ${styles.headingGridItem?.css}
        ${commonHeadingShipStyles}
    `,
};

styles.headingText = {
    ...styles.headingText,
    variant: "h4",
};

styles.selectSavedAddressLink = {
    ...styles.selectSavedAddressLink,

    css: css`
        ${styles.selectSavedAddressLink?.css}
        ${commonShipLinkStyles}
    `,
};
